var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-nav pt-2"},[_c('b-navbar',{staticClass:"container",attrs:{"variant":"faded","type":"dark"}},[_c('b-navbar-brand',{attrs:{"to":"/"}},[_c('HeaderLogo',{attrs:{"inline":true}})],1),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('b-nav-item',{on:{"click":_vm.logout}},[_vm._v("Log out")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }